/**
 * Compatibility Layer for BrokerIntegrationContext
 * Maps old API to new BrokerConnectionsProvider
 */

import { useBrokerConnections } from '../providers/BrokerConnectionsProvider';

// Export hook with old name but using new provider
export const useBrokerIntegration = () => {
  const {
    connections,
    activeConnections,
    expiredConnections,
    selectedAccounts,
    hasConnections,
    hasExpiredConnections,
    hasAnyConnections,
    connectionCount,
    loading,
    error,
    connectBroker,
    disconnectBroker,
    fetchAccountBalances,
    getConnectionByBroker,
    SUPPORTED_BROKERS
  } = useBrokerConnections();

  // Map new API to old API for compatibility
  return {
    // Renamed properties
    brokerIntegrations: connections,

    // Actions with old names
    addBrokerIntegration: connectBroker,
    deleteBrokerIntegration: async (integrationId) => {
      console.log('🔍 BrokerIntegrationContextCompat.deleteBrokerIntegration called with:', integrationId);
      
      // เรียก disconnectBroker ก่อน
      await disconnectBroker(integrationId);
      
      // ลบ engagement data จาก tbl_engagement ทันที - COMMENTED OUT
      // console.log('🗑️ ลบ engagement data...');
      // const { collection, query, where, getDocs, writeBatch } = await import('firebase/firestore');
      // const { db, auth } = await import('../services/firebase');
      
      // const userId = auth.currentUser?.uid;
      // if (userId) {
      //   const engagementQuery = query(
      //     collection(db, 'tbl_engagement'),
      //     where('userId', '==', userId)
      //   );
      
      //   const snapshot = await getDocs(engagementQuery);
      //   console.log('🔍 พบ engagement documents:', snapshot.size);
      
      //   if (!snapshot.empty) {
      //     const batch = writeBatch(db);
      //     snapshot.docs.forEach((doc) => {
      //       console.log('🗑️ ลบ document:', doc.id);
      //       batch.delete(doc.ref);
      //     });
      
      //     await batch.commit();
      //     console.log(`✅ ลบ engagement documents เรียบร้อย: ${snapshot.size} documents`);
      //   }
      // }
    },
    updateBrokerIntegration: async (integrationId, updates) => {
      console.warn('updateBrokerIntegration is deprecated. Updates should be handled by backend.');
      // Return success for compatibility but don't actually update
      return true;
    },

    // Status object for compatibility
    brokerStatus: {
      normalizedIntegrations: connections,
      connectionsWithStatus: connections,
      activeConnections,
      expiredConnections,
      hasConnections,
      hasExpiredConnections,
      connectionCount
    },

    // Direct properties
    activeConnections,
    expiredConnections,
    selectedAccounts,
    hasConnections,
    hasExpiredConnections,
    hasAnyConnections,
    connectionCount,
    normalizedIntegrations: connections,
    loading,
    error,

    // Actions
    fetchAccountBalances,
    fetchAccountData: fetchAccountBalances, // Alias for compatibility
    getIntegrationByBroker: getConnectionByBroker,
    verifyBrokerConnection: async (integrationId) => {
      console.warn('verifyBrokerConnection is deprecated. Verification handled by backend.');
      return true;
    },
    refreshIntegrations: async () => {
      // Real-time updates are handled via Firestore subscriptions
      // This function is kept for compatibility but does nothing
      return true;
    },

    // Hooks
    useBrokerStatus: () => ({
      normalizedIntegrations: connections,
      activeConnections,
      expiredConnections,
      hasConnections,
      hasExpiredConnections,
      connectionCount
    }),

    // Constants
    SUPPORTED_BROKERS,

    // Account data (empty for compatibility)
    accountData: {},
    statusLoading: false
  };
};

// Re-export provider with old name for compatibility
export { BrokerConnectionsProvider as BrokerIntegrationProvider } from '../providers/BrokerConnectionsProvider';